import awsEC2Instances from './awsEC2Instances';

export default awsEC2Instances;
